import {    Injectable          } from '@angular/core';

import {    TranslateHttpLoader } from '@ngx-translate/http-loader';
import {    HttpClient          } from '@angular/common/http';
import {    SessionManager      } from '../session/session.manager';

import {    isSessionCode  , 
            SessionCode         } from 'src/app/enums/session/session-code.enum';

import {    TranslateService    }   from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';

import { AvailableLocale } from 'src/app/enums/locale/available-locale.enum';
import { DateAdapter } from '@angular/material/core';

import  * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class LocaleManager {

    constructor(
        private sessionManager  : SessionManager    ,
        private translate       : TranslateService  ,
        private dateAdapter     : DateAdapter<moment.Moment>
    ) { }

    initLocales () 
    {
        registerLocaleData(    
            localeIt, AvailableLocale.ITALIAN
        )

        registerLocaleData(    
            localeEn, AvailableLocale.ENGLISH
        )

        this.recovery();
    }

    recovery()
    {        
        let locale: any = this.sessionManager.locale().get()        
        
        if(isSessionCode(locale))
        {
            switch (locale) {
                case SessionCode.GENERIC        : 
                    this.setLocale ( AvailableLocale.DEFAULT )
                break
                case SessionCode.MISSING_VALUE  :                 
                    this.setLocale ( this.translate.getBrowserLang() as any )
                break
                default:
                    this.setLocale ( this.translate.getBrowserLang() as any )
                break
            }
        }else
        {
            this.setLocale ( locale )
        }
    }

    setLocale ( language: AvailableLocale ) 
    {
        switch(language)
        {
            case AvailableLocale.ENGLISH:
                this.registerLocale ( AvailableLocale.ENGLISH ) 
            break;
            case AvailableLocale.ITALIAN:
                this.registerLocale ( AvailableLocale.ITALIAN ) 
            break;
            case AvailableLocale.DEFAULT:
                this.registerLocale ( AvailableLocale.DEFAULT ) 
            break;
            default: 
                this.registerLocale ( AvailableLocale.DEFAULT ) 
            break;
        }
        
    }

    registerLocale( locale: AvailableLocale ){
        moment  .                locale         (   locale  );
        this    .dateAdapter    .setLocale      (   locale  );    
        this    .sessionManager .locale().set   (   locale  )
    }

}

export class DynamicLocaleId extends String {
    locale: string;
  
    toString() {
      return this.locale;
    }
  }
  
